export enum ModalType {
  RetailerInfo = "retailer-info",
  ProductAddedToCart = "product-added-to-cart",
  Loading = "loading",
  CookieConsent = "cookie-consent",
  LocalPlus = "local-plus",
  DutiesAndTaxes = "duties-and-taxes",
  RefurbishedInfo = "refurbished-info",
  DutiesInformation = "duties-information",
  NoAdditionalDutiesInformation = "no-additional-duties-information",
  LocalePicker = "locale-picker",
}

export type ModalPosition = "center" | "bottom-left";

export type ModalSize = "sm" | "md" | "lg" | "xl";

export type ModalSettings = {
  allowClose?: boolean;
  ariaLabel?: string;
  ariaDescribedby?: string;
  onOpen?: () => void;
  onClose?: () => void;
  position?: ModalPosition;
  size?: ModalSize;
};
